
import { Injectable } from '@angular/core';
import { AngularFireStorage } from '@angular/fire/storage';
import { Events} from 'ionic-angular';
import { DataProvider } from '../data/data';
import { finalize } from 'rxjs/operators';
import { first } from 'rxjs/operators';
/*
  Generated class for the MediaProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class MediaProvider {

  constructor( private fbStorage: AngularFireStorage,public events: Events,private data:DataProvider) {
    console.log('Hello MediaProvider Provider');

  }


  intializeSubscriptions(){

   	 this.events.subscribe('media:uploadImage', (id, index,img) => {

      	this.uploadImage(id,index,img);

     });

     this.events.subscribe('media:uploadUserPhoto', (uid,img) => {

        this.uploadUserPhoto(uid,img);

     });

    

   }

   uploadImage(id,index,img){
   		
   		          const imgRef = this.fbStorage.ref('images/'+new Date().getTime().toString()+'.png');
                const imageUpload = imgRef.putString(img,'data_url');
                imageUpload.snapshotChanges().pipe(
                    finalize(() =>  {
                        const downloadURL = imgRef.getDownloadURL();
                        downloadURL.subscribe(url=> {
                         	this.events.publish('media:downloadUrl',id,index,url);
                        })
                    })
                 )
                .subscribe()
   }

   async uploadUserPhoto(uid,imgData){
                 
                 console.log("inside media photo:"+uid);

                 const imgRef = this.fbStorage.ref(uid+'/images/'+new Date().getTime().toString()+'.png');

                 await imgRef.putString(imgData,'data_url');

                 const downloadURL = await imgRef.getDownloadURL().pipe(first()).toPromise();

                 console.log("download url");
                 console.log(downloadURL);

                 this.events.publish('media:userPhotoUrl',uid,downloadURL);
   
   }

  

   removeSubscriptions(){
     this.events.unsubscribe('media:uploadImage');
     this.events.unsubscribe('media:uploadUserPhoto');
   }


}



// WEBPACK FOOTER //
// ./src/providers/media/media.ts